import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AppNotificationUtilClass } from '@monorepo/services';
import { MOBILE_SCREEN_UTILS } from '@monorepo/ui';

@Injectable({
  providedIn: 'root',
})
export class NavigationServiceGuard implements CanActivate {
  isMobileOrTabletScreen = false;
  constructor(private APIHelper: AppNotificationUtilClass) {
    this.isMobileOrTabletScreen = MOBILE_SCREEN_UTILS.isTabletScreen();
  }

  canActivate(): boolean {
    if (!this.isMobileOrTabletScreen)
      this.APIHelper.showPopup(
        'Application not available on web!',
        'Please change the view to mobile or tablet and reload the page.',
      );
    return this.isMobileOrTabletScreen;
  }
}
